export default __webpack_public_path__ + "images/c48d0868f745409fdb817adc08422a3f.svg";